import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
// import { List, ListItem, Box, Button, IconButton } from '@mui/material';
import { List, ListItem, Box, Button, useMediaQuery } from '@mui/material';
import { useTheme, Theme } from '@mui/material/styles';
// import MenuIcon from '@mui/icons-material/Menu';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import SchoolIcon from '@mui/icons-material/School';
import WorkIcon from '@mui/icons-material/Work';
import AssignmentIcon from '@mui/icons-material/Assignment';
import CardMembershipIcon from '@mui/icons-material/CardMembership';

const sections = [
  { name: 'Profile', path: '/', icon: <AccountBoxIcon /> },
  { name: 'Education', path: '/education', icon: <SchoolIcon /> },
  { name: 'Academic Projects', path: '/academic-projects', icon: <AssignmentIcon /> },
  { name: 'Work Experience', path: '/work-experience', icon: <WorkIcon /> },
  { name: 'Certifications', path: '/certifications', icon: <CardMembershipIcon /> },
];

const sidebarListStyle = {
  fontWeight: 'bold',
  color: '#fffde7',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  flex: 1,
};

const Sidebar: React.FC<{ location: any; isSidebarOpen: boolean; setIsSidebarOpen: (isOpen: boolean) => void }> = ({location, isSidebarOpen, setIsSidebarOpen}) => {
  const navigate = useNavigate();
  const [active, setActive] = useState('/');
  const theme = useTheme<Theme>(); // Get the theme and ensure it is of type Theme
  const isLargerThanMedium = useMediaQuery(theme.breakpoints.up('md'));

  useEffect(() => {
    setActive(location.pathname)
  }, [location])

  const handleNavigation = (path: string) => {
    navigate(path);
    setActive(path);
  };
  
  const sidebarStyle = {
    width: isSidebarOpen ? '20vw' : '0',
    transition: 'width 0.5s ease',
    overflow: 'hidden', 
      backgroundImage: `url('water-bubbles.png')`,
  fontWeight: 'bold',
  display: 'flex',
    flexDirection: 'column',
  };

    const buttonStyles = (path: string) => ({
    color: 'white',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: 'bold',
    backgroundColor: active === path ? '#003333' : 'transparent',
    transition: 'all 0.2s ease',
      fontSize: '1rem',
    '& .MuiButton-startIcon': {
      marginRight: isLargerThanMedium ? '5px' : 0,
      '& .MuiSvgIcon-root': {
        fontSize: '1.5rem',
    },
  },
    '&:hover': {
      fontSize: '1.2rem',
      '& .MuiSvgIcon-root': {
        transform: 'scale(1.4)',
      },
      paddingTop: '0.5rem',
    paddingBottom: '0.5rem',
    },
    // padding: '1rem 0 1rem 0',
    // borderRadius: '50% / 20%',
    // borderRadius: '50rem',
    // borderRadius: '0 50% 50% 0',
    // borderRadius: '0 10% 10% 0',
    // boxShadow: '0 2px 4px rgba(0, 0, 0, 0.3)',
    boxShadow: '0 8px 16px rgba(0, 0, 0, 0.8)', 
  });

  return (
    <Box sx={sidebarStyle}>
      <Box sx={{bgcolor: 'rgba(26, 104, 87, 0.9)', flex: 1,  paddingTop: '10vh', justifyContent: 'center',
            alignItems: 'center',}}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            mb: 2,
          }}
        >
          <img
            src="/anjali-profile-photo.jpeg"
            alt="Profile"
            style={{
              width: '12vw',
              height: '12vw',
              borderRadius: '50%',
              objectFit: 'fill',
              border: '2px solid #003333',
            }}
          />
        </Box>
        <List sx={sidebarListStyle}>
         {sections.map((section, index) => (
          <ListItem key={index} sx={{justifyContent: 'center', alignItems:'center'}}>
            <Button
              sx={buttonStyles(section.path)}
              fullWidth={isLargerThanMedium}
              startIcon={section.icon}
              onClick={() => handleNavigation(section.path)}
              aria-label={section.name}
            >
               {isLargerThanMedium ? section.name : null}
            </Button>
          </ListItem>
        ))}
        </List>
        </Box>
      </Box>
  );
};

export default Sidebar;
